document.addEventListener('DOMContentLoaded', function () {

  /* HERO SLIDER */
  (function () {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('.hero-slide'));
    var dotsWrap = slider.querySelector('[data-hero-dots]');
    var total = slides.length;
    var current = 0;
    var timer = null;
    var DELAY = 4500;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    dotsWrap.innerHTML = '';
    var dots = slides.map(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'hero-dot' + (i === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', 'Show photo ' + (i + 1));
      d.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(d);
      return d;
    });

    function go(i) {
      current = (i + total) % total;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === current); });
    }
    function start() {
      if (reduceMotion || total < 2) return;
      stop();
      timer = setInterval(function () { go(current + 1); }, DELAY);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    start();
  })();

  /* CATERING FORM */
  (function () {
    var form = document.getElementById('catering-form');
    if (!form) return;

    var boxes       = form.querySelectorAll('.cat-chip input');
    var hidden      = document.getElementById('cat-looking-hidden');
    var group       = form.querySelector('.cat-options');
    var err         = form.querySelector('.cat-options-error');
    var otherToggle = document.getElementById('cat-other-toggle');
    var otherWrap   = document.getElementById('cat-other-wrap');
    var otherInput  = document.getElementById('cat-other');
    var success     = document.getElementById('cat-success');

    function sync() {
      var picked = Array.prototype.filter.call(boxes, function (b) { return b.checked; })
        .map(function (b) { return b.value; });
      hidden.value = picked.join(', ');
      otherWrap.hidden = !otherToggle.checked;
      otherInput.required = otherToggle.checked;
      if (picked.length) { group.classList.remove('is-invalid'); err.hidden = true; }
      return picked.length;
    }

    boxes.forEach(function (b) { b.addEventListener('change', sync); });

    form.addEventListener('submit', function (e) {
      if (!sync()) {
        e.preventDefault();
        group.classList.add('is-invalid');
        err.hidden = false;
        group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    if (window.location.search.indexOf('contact_posted=true') > -1) {
      success.classList.add('active');
      document.getElementById('catering').scrollIntoView({ block: 'start' });
    }
  })();

});
